import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "../styles/download.css";
import { downloadPdfLead } from "../api/company";

const PDF_FILE_URL = "/files/OKboard-checklist-OKR-Ready.pdf";
const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());

export default function DownloadPDF() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [agree, setAgree] = useState(true);
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const emailValid = isValidEmail(email);
  const canSubmit = emailValid && agree && !submitting;

  function triggerDownload(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setTouched(true);
    setError("");
    if (!canSubmit) return;

    try {
      setSubmitting(true);
      await downloadPdfLead(email);

      setSuccess(true);
      setTouched(false);

      triggerDownload(PDF_FILE_URL, "OKboard-checklist-OKR-Ready.pdf");
    } catch (err) {
      setError(err.message || t('download_pdf.error'));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="dpdf-wrap">
      <div className="dpdf-card">
        <h1 className="dpdf-title">{t('download_pdf.title')}</h1>
        <p className="dpdf-sub">{t('download_pdf.subtitle')}</p>

        {success ? (
          <div className="dpdf-successBlock">
            <p className="dpdf-successBig">{t('download_pdf.success_big')}</p>
            <p className="dpdf-successHint">
              {t('download_pdf.success_hint_prefix')}{" "}
              <a href={PDF_FILE_URL} download>{t('download_pdf.success_hint_link')}</a>.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <label className="dpdf-label" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="you@company.com"
              className={`dpdf-input ${touched && !emailValid ? "dpdf-input--error" : ""}`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={() => setTouched(true)}
            />
            {touched && !emailValid && (
              <div className="dpdf-error">{t('download_pdf.invalid_email')}</div>
            )}

            <label className="dpdf-check">
              <input
                type="checkbox"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
              />
              <span>
                {t('download_pdf.agree_prefix')}{" "}
                <Link to="/privacy" target="_blank" rel="noopener noreferrer">
                  {t('download_pdf.privacy_link')}
                </Link>
              </span>
            </label>

            {error && <div className="dpdf-error">{error}</div>}

            <button type="submit" className="dpdf-btn" disabled={!canSubmit}>
              {submitting ? t('download_pdf.submitting') : t('download_pdf.submit')}
            </button>
          </form>
        )}

        <p className="dpdf-note">{t('download_pdf.note')}</p>
      </div>
    </section>
  );
}
